import { render, staticRenderFns } from "./Households.vue?vue&type=template&id=77188051&"
import script from "./Households.vue?vue&type=script&lang=js&"
export * from "./Households.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports